import {
  SKILLS_ADMIN_LIST_FAIL,
  SKILLS_ADMIN_LIST_REQUEST,
  SKILLS_ADMIN_LIST_SUCCESS,
  SKILLS_BULK_VERIFY_FAIL,
  SKILLS_BULK_VERIFY_REQUEST,
  SKILLS_BULK_VERIFY_SUCCESS,
  SKILLS_CSV_UPLOAD_FAIL,
  SKILLS_CSV_UPLOAD_REQUEST,
  SKILLS_CSV_UPLOAD_SUCCESS,
  SKILLS_MANUAL_UPLOAD_FAIL,
  SKILLS_MANUAL_UPLOAD_REQUEST,
  SKILLS_MANUAL_UPLOAD_SUCCESS,
} from "../../Constants/SkillConstants";

const initialListState = {
  status: false,
  data: { row: [], total_count: 0, count: 0 },
  loading: true,
  error: null,
};

const initialOperationState = {
  status: false,
  data: null,
  loading: false,
  error: null,
};

export const SkillsAdminListReducer = (
  state = initialListState,
  action: any
) => {
  try {
    if (action.type === SKILLS_ADMIN_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === SKILLS_ADMIN_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === SKILLS_ADMIN_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const SkillsManualUploadReducer = (
  state = initialOperationState,
  action: any
) => {
  try {
    if (action.type === SKILLS_MANUAL_UPLOAD_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === SKILLS_MANUAL_UPLOAD_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === SKILLS_MANUAL_UPLOAD_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const SkillsCsvUploadReducer = (
  state = initialOperationState,
  action: any
) => {
  try {
    if (action.type === SKILLS_CSV_UPLOAD_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === SKILLS_CSV_UPLOAD_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === SKILLS_CSV_UPLOAD_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const SkillsBulkVerifyReducer = (
  state = initialOperationState,
  action: any
) => {
  try {
    if (action.type === SKILLS_BULK_VERIFY_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === SKILLS_BULK_VERIFY_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === SKILLS_BULK_VERIFY_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};
